import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CREATE_SPARE_PART_TRANSACTION_SUCCESS,
  FETCH_SPARE_PART_TRANSACTION_SUCCESS,
  GET_SPARE_PART_TRANSACTION_SUCCESS,
  SAVE_SPARE_PART_TRANSACTION_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_SPARE_PART_TRANSACTION_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SPARE_PART_TRANSACTION_QUERY,
    query,
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_SPARE_PART_TRANSACTION_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_SPARE_PART_TRANSACTION_SUCCESS,
    data,
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {sparePartTransaction} = store.getState();
      const {query} = sparePartTransaction;
      const response = await axios.get(`/spare-part-transaction?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/spare-part-transaction`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/spare-part-transaction');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/spare-part-transaction/${id}`, payload);
      if(response && response.data && response.data.message) {
        dispatch(fetchSuccess());
        return message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.goBack();
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/spare-part-transaction/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/spare-part-transaction/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
